import { render, staticRenderFns } from "./createAlipayChatDetails.vue?vue&type=template&id=6deade06&scoped=true&"
import script from "./createAlipayChatDetails.vue?vue&type=script&lang=js&"
export * from "./createAlipayChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./createAlipayChatDetails.vue?vue&type=style&index=0&id=6deade06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deade06",
  null
  
)

export default component.exports